const frenchLocale = {
  name: "frenchLocale",
  months: [
    ["Janvier", "jan"],
    ["Février", "fév"],
    ["Mars", "mar"],
    ["Avril", "avr"],
    ["Mai", "mai"],
    ["Juin", "juin"],
    ["Juillet", "juil"],
    ["Août", "aoû"],
    ["Septembre", "sep"],
    ["Octobre", "oct"],
    ["Novembre", "nov"],
    ["Décembre", "déc"],
  ],
  weekDays: [
    ["Samedi", "S"],
    ["Dimanche", "D"],
    ["Lundi", "L"],
    ["Mardi", "M"],
    ["Mercredi", "M"],
    ["Jeudi", "J"],
    ["Vendredi", "V"],
  ],
  digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
  meridiems: [
    ["AM", "am"],
    ["PM", "pm"],
  ],
};

export default frenchLocale;
